import React from 'react';
import { Modal } from 'antd';
import type { ButtonProps } from 'antd';

type ConfirmProps = {
  visible: boolean;
  title?: React.ReactNode;
  content?: React.ReactNode;
  okText?: string;
  cancelText?: string;
  okType?: 'primary' | 'danger' | 'default' | 'link' | 'text';
  onOk: () => void | Promise<void>;
  onCancel: () => void;
  maskClosable?: boolean;
  centered?: boolean;
  footer?: React.ReactNode | null;
  className?: string;
  bodyStyle?: React.CSSProperties;
  width?: number;
  okButtonProps?: ButtonProps;
  cancelButtonProps?: ButtonProps;
};

const ConfirmModal: React.FC<ConfirmProps> = ({
  visible,
  title = 'Are you sure?',
  content = null,
  okText = 'Ok',
  cancelText = 'Cancel',
  okType = 'danger',
  onOk,
  onCancel,
  maskClosable = false,
  centered = true,
  footer = undefined,
  className = undefined,
  bodyStyle = undefined,
  width = undefined,
  okButtonProps = undefined,
  cancelButtonProps = undefined,
}) => {
  return (
    <Modal
      open={visible}
      title={title}
      onOk={onOk}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      okType={okType as any}
      maskClosable={maskClosable}
      centered={centered}
      footer={footer}
      className={className}
      bodyStyle={bodyStyle}
      width={width}
      okButtonProps={okButtonProps}
      cancelButtonProps={cancelButtonProps}
    >
      {content}
    </Modal>
  );
};

export default ConfirmModal;
